import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateOfferRegionFilterExclusionPayload, createOfferRegionFilterExclusion } from '~/services/PromoService';

import { offerRegionFilterExclusionQueryKeys } from './offerRegionFilterExclusionQueryKeys';

export function useCreateOfferRegionFilterExclusion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateOfferRegionFilterExclusionPayload) => createOfferRegionFilterExclusion(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerRegionFilterExclusionQueryKeys.lists() });
    },
  });
}
